import axios, { AxiosResponse } from 'axios'

export const instance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_BACKEND_HOST}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const responseBody = (response: AxiosResponse) => response.data

export const requests = {
  get: (url: string, params?: Record<string, any>) =>
    instance.get(url, params).then(responseBody),
  post: (url: string, body: {}, options?: Record<string, any>) =>
    instance.post(url, body, options).then(responseBody),
  put: (url: string, body: {}, config?: Record<string, any>) =>
    instance.put(url, body, config).then(responseBody),
  patch: (url: string, body: {}) =>
    instance.patch(url, body).then(responseBody),
  delete: (url: string) => instance.delete(url).then(responseBody),
}
